import { Modal, Button, Form, Table, Stack, Col } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const ToothFilledCountModal = ({ value = '', onSave, onFilledTeethCountChange }) => {
    const [note, setNote] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [savedNote, setSavedNote] = useState(value);

    // Sinkronisasi note saat modal dibuka
    useEffect(() => {
        if (showModal) {
            setNote(savedNote);
        }
    }, [showModal, savedNote]);

    // Update jika value dari parent berubah
    useEffect(() => {
        setSavedNote(value);
        setNote(value);
    }, [value]);

    const handleSave = () => {
        if (note.trim()) {
            setSavedNote(note);
            onSave(note);
            setShowModal(false);
        }
    };

    return (
        <Col>
            <Stack>
                {savedNote ? (
                    <Table
                        bordered
                        size="sm"
                        className="mt-2 mb-0"
                        style={{
                            cursor: 'pointer',
                            fontSize: '0.8rem',
                            width: '100%',
                            maxWidth: '100%',
                            borderColor: '#dee2e6',
                        }}
                        onClick={() => setShowModal(true)}
                    >
                        <thead className="table-light">
                            <tr>
                                <th
                                    style={{
                                        padding: '4px 8px',
                                        backgroundColor: '#dee2e6',
                                        fontWeight: '600',
                                        fontSize: '0.75rem',
                                        textAlign: 'left',
                                        color: '#343a40',
                                    }}
                                >
                                    Jumlah Gigi Filled
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '4px 8px', whiteSpace: 'pre-wrap' }}>
                                    • {savedNote}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                ) : (
                    <Button
                        size="sm"
                        onClick={() => setShowModal(true)}
                        style={{
                            width: '100%',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            textAlign: 'center',
                            fontSize: '0.75rem',
                            lineHeight: '1rem',
                            padding: '4px',
                            backgroundColor: 'transparent',
                            color: '#343a40',
                            borderColor: '#ced4da',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                        }}
                    >
                        Jumlah Gigi Filled
                    </Button>
                )}
            </Stack>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Jumlah Gigi Filled</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="filledTeethNote">
                        <Form.Control
                            type="number"
                            min={0}
                            placeholder="0"
                            value={note}
                            onChange={(e) => {
                                const val = e.target.value;
                                setNote(val);

                                if (typeof onFilledTeethCountChange === 'function') {
                                    onFilledTeethCountChange(val);
                                }
                            }}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Batal
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSave}
                        disabled={!note.trim()}
                    >
                        Simpan
                    </Button>
                </Modal.Footer>
            </Modal>
        </Col>
    );
};

export default ToothFilledCountModal;
